"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useColor = useColor;

var _toColor = require("../toColor");

var _react = require("react");

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 * Returns a stateful `Color`, and a function to update it.
 * @param format The color format.
 * @param initialColor The initial color in the selected color format.
 * @see [WHAT IS "COLOR"?](https://github.com/Wondermarin/react-color-palette#color)
 */
function useColor(format, initialColor) {
  var getColor = (0, _react.useCallback)(function () {
    if (format === "hex") {
      var _color = initialColor;
      return (0, _toColor.toColor)("hex", _color);
    } else if (format === "rgb") {
      var _color2 = initialColor;
      return (0, _toColor.toColor)("rgb", _color2);
    } else if (format === "hsb") {
      var _color3 = initialColor;
      return (0, _toColor.toColor)("hsb", _color3);
    }

    return (0, _toColor.toColor)("hex", "#000000");
  }, [format, initialColor]);

  var _useState = (0, _react.useState)(getColor),
      _useState2 = _slicedToArray(_useState, 2),
      color = _useState2[0],
      setColor = _useState2[1];

  (0, _react.useEffect)(function () {
    setColor(getColor);
  }, [getColor]);
  return [color, setColor];
}